import React, { FC, ReactElement } from 'react';
import { useParams } from 'react-router-dom';

import IdeaForm from 'buyside/components/presentation/IdeaForm/ideaForm';
import LoadingSpinner from 'buyside/components/presentation/LoadingSpinner/loadingSpinner';
import WhitePaperForm from 'buyside/components/presentation/WhitePaperForm/whitePaperForm';

import { useIdeaSubmissionQuery, useWhitePaperSubmissionQuery } from 'interfaces/graphql-typings';

const ResearchSubmissionQuery: FC<{
  component: typeof IdeaForm | typeof WhitePaperForm;
  useQuery: typeof useIdeaSubmissionQuery | typeof useWhitePaperSubmissionQuery;
}> = ({ component, useQuery }): ReactElement => {
  const { id } = useParams();

  const { data, error, loading } = useQuery({ skip: !id, variables: { id: `${id}` } });

  if (loading) return <LoadingSpinner />;
  if (error) throw error;

  const Component = component;

  // @ts-ignore
  // Type 'IdeaSubmissionQuery | WhitePaperSubmissionQuery | undefined' is not assignable to type '(IdeaSubmissionQuery & WhitePaperSubmissionQuery) | undefined'
  return <Component data={data} id={id} />;
};

export default ResearchSubmissionQuery;
